export class MxAdvancedSearchQueryCustomCtrl {
	$inject = ['mx.SolutionBuilderAgent.SearchQuery'];

	value;
	value2;
	value3;

	constructor(SearchQuery) {
		this.SearchQuery = SearchQuery;
	}

	$onInit() {
		this.context = {
			datasource: this.value2,
			widgetId: this.value3,
		};

		this.query = new this.SearchQuery(this.value);
	}
}

angular.module('mx.SolutionBuilderAgent').directive('mxAdvancedSearchQueryCustom', [
	function mxAdvancedSearchQueryCustomDirective() {
		return {
			restrict: 'E',
			scope: {},
			bindToController: {
				value: '=',
				value2: '=',
				value3: '=',
			},
			controller: MxAdvancedSearchQueryCustomCtrl,
			controllerAs: 'vm',
			template: '<mx-advanced-search-query query="vm.query" context="vm.context"> </mx-advanced-search-query>',
		};
	},
]);
